module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block__icon",
    class: _vm.classMod
  }), _c('div', {
    staticClass: "block__wrapp"
  }, [_c('h3', {
    staticClass: "block__name"
  }, [_vm._v(_vm._s(_vm.name) + ":")]), _c('p', {
    staticClass: "block__result"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ad46e32","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/modules/modulemain/components/mainfootericonblock/MainFooterBlock.vue
// module id = aa160825c9b05e05f1f3
// module chunks = 0